export const quotes = [
  {
    id: 1,
    name: "Nji Daniel",
    username: "NjiDaniel",
    url: "https://www.twitter.com/NJIDANIEL4",
    role: "Software Engineer",
    avatar:
      "https://pbs.twimg.com/profile_images/1534382919929716736/SjDzLqaI_400x400.jpg",
    quote:
      "A dedicated and hardworking individual who is always ready to learn and improve. He is a great team player and a good communicator.",
  },
  {
    id: 2,
    name: "Ekwoge Blaise",
    username: "ekwoge_blaise",
    url: "https://www.linkedin.com/in/ekwogeeseh/",
    role: "Software Developer Lead ",
    avatar: require("./assets/Screenshot from 2023-02-23 17-24-45.png"),
    quote:
      "Mr. Terence is a professional and an enthusiastic engineer, quite creative. He always get the job done and respect deadlines even if it means working overtime. More to that he is a great team player. Elated to have worked with him.",
  },
  // {
  //   id: 3,
  //   name: "John McDoe",
  //   username: "RootMultivate",
  //   url: "",
  //   role: "Entrepreneur",
  //   quote: "This guy never stops learning and is always ready to help others.",
  // },
  // {
  //   id: 4,
  //   name: "Robert MickLand",
  //   username: "MickLand",
  //   url: "",
  //   role: "Project Manager",
  //   quote:
  //     "I have worked with Terence on several projects and he is a great team player.",
  // },
];
